export * from "./minivan-icon.component";
